<template>
  <div class="pro-detail">
    <div class="back-btn" @click="$router.go(-1)">
      <img src="@/assets/image/mobile/back-btn.png">
      BACK
    </div>
    <div class="title">{{currentProduct.itemName}}
      <div>{{currentProduct.itemIntro}}</div>
    </div>
    <img :src="$img + currentProduct.img" class="pro-img">
    <mbFooter></mbFooter>
  </div>
</template>

<script>
  import mbFooter from "../../components/mobile/mbFooter"

  export default {
    components:{mbFooter},
    name: "mobileProductDetail",
    data() {
      return {
        currentProduct: {
          itemName:'',
          itemIntro:'',
          img:''
        },
        // productInfo:[]
      }
    },
    mounted() {
      // this.productInfo = productInfo
      const id = this.$route.query.id
      this.currentProduct.itemIntro = this.$route.query.itemIntro
      // const productType = this.$route.query.productType
      // switch (productType) {
      //   case 0:this.currentProduct = productInfo.miniInfo[id - 1];break;
      //   case 1:this.currentProduct = productInfo.webInfo[id - 1];break;
      //   case 2:this.currentProduct = productInfo.officeInfo[id - 1];break;
      //   case 3:this.currentProduct = productInfo.saleInfo[id - 1];break;
      //   case 4:this.currentProduct = productInfo.appInfo[id - 1];break;
      // }
      // console.log(this.currentProduct)
      this.$http.get('/api/item/img/list',{params:{itemId:id}}).then((res)=>{
        // console.log(res)
        this.currentProduct.img = res.data.rows[0].img
        this.currentProduct.itemName = res.data.rows[0].itemName
      })
    }
  }
</script>

<style scoped>
  .back-btn {
    width: 100vw;
    font-size: .69em;
    height: 8vw;
    /*border-bottom: .8px solid #dbdbdb;*/
    letter-spacing: .1em;
    padding: 4vw 0 0 5vw;
    box-shadow: 0 1px 3px #f0f0f5;
    margin-bottom: 4vw;
    position: fixed;
    top: 0;
    left: 0;
    background-color: #fff;
  }

  .back-btn img {
    /*width: 5vw;*/
    height: 3vw;
  }

  .title {
    font-size: 1.2em;
    font-weight: bold;
    width: 90%;
    margin: 18vw auto 5vw;
  }

  .title div {
    font-size: .7em;
    margin: 5vw auto;
    color: #768087;
    /*width: 90%;*/
    line-height: 160%;
    letter-spacing: 0.1em;
    font-weight: 300;
  }

  .pro-img {
    width: 100%;
    margin: 0 auto;
    display: block;
    margin-bottom: 10vw;
  }

</style>



// WEBPACK FOOTER //
// src/pages/product/mobileProductDetail.vue